import React from 'react'
import Button from '../shared/Button'

const BottomHero = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-5 my-20">
    <div className="md:col-span-2 lg:col-span-1 xl:col-span-1 rounded-[15px] shadow-lg h-[350px]">
      <img src='/BottomCard1.png' alt='bottom-card-1' className=' h-full w-full rounded-[15px]' />
    </div>
    <div className="md:col-span-2 lg:col-span-1 xl:col-span-1 rounded-[15px] shadow-lg h-[350px]">
    <img src='/BottomCard2.png' alt='bottom-card-1' className=' h-full w-full rounded-[15px]' />
    </div>
    <div className="md:col-span-2 lg:col-span-1 xl:col-span-1 rounded-[15px] shadow-lg h-[350px]">
    <img src='/BottomCard3.jpg' alt='bottom-card-1' className=' h-full w-full rounded-[15px]' />
    </div>
    <div className="md:col-span-2 lg:col-span-1 xl:col-span-1 bg-white rounded-[15px] shadow-lg h-[350px]">
     <div className="h-full w-full flex flex-col justify-start items-center p-4 gap-4">
        <div>
            <img src='/Deal.png' alt='deal' />
        </div>
        <p className='text-xl text-center'>
            Adding 11 herbs and spices, Explore our menu and add items to your cart.
        </p>
        <div>
        <   Button data="EXPLORE MENU" type="solid" />
        </div>
     </div>
    </div>
  </div>  
  )
}

export default BottomHero
